import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { validateForm } from "utils/validation";
import Spinner from "Common/Globle/Spinner";
import EditHallImagesForm from "./Components/EditHallImagesForm";
import fields from "../json/HallImageField.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import useFetchAllData from "Hooks/useFetchAllData";
import { updateHallImage, getHallImageWithId, getHallList } from "adminApi/HallImagesApi/HallImage";
import { HallImagesRules } from "validation/ValidationRules";

const EditHallImages = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    // Build initial values from field definitions
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, handleFileChange, setValues, setErrors } = useFormChange(
        initialValues,
        HallImagesRules
    );

    const { loading: loadingFetch } = useFetchFormDataById(id, formdata, getHallImageWithId, setValues);

    // Fetch room list in parent — not inside the form component
    const { data: roomList, loading: loadingRoomList } = useFetchAllData(getHallList);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => {
                formData.append(key, val ?? "");
            });
            return await updateHallImage({ id, data: formData });
        },
        (vals) => {
            // Copy before mutating to avoid modifying original state
            const v = { ...vals };
            if (typeof v.hall_image === "string") delete v.hall_image;
            delete v.hall_imagePreview;
            const err = validateForm(v, HallImagesRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Hall Images updated successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingFetch || loadingRoomList) && <Spinner isSpinner={true} />}
            <EditHallImagesForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleFileChange={handleFileChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                imagePreview={values.hall_imagePreview || values.hall_image}
                loading={loadingSubmit}
                roomList={roomList || []}
                title="Update Hall Image"
            />
        </>
    );
};

export default EditHallImages;
